<template>
<div class="header__wrapper" v-if="isLoggedIn">
  <div class="header__nav">
    <v-toolbar flat>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat :to="{name: 'Users'}" active-class="link-active">Users</v-btn>
        <v-btn flat :to="{name: 'Notifications'}" active-class="link-active">Notifications</v-btn>
        <v-btn flat :to="{name: 'MediaCenter'}" active-class="link-active">Media Center</v-btn>
        <v-btn flat :to="{name: 'Editors'}" active-class="link-active">Editors/authors</v-btn>
        <v-btn flat :to="{name: 'Permissions'}" active-class="link-active">Permissions</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-btn flat active-class="link-active">Logout</v-btn>
  </div>
  <div class="header__nav">
    <v-toolbar flat>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat :to="{name: 'FMContent'}" active-class="link-active">FM Content</v-btn>
        <v-btn flat :to="{name: 'HeaderPage'}" active-class="link-active">Header</v-btn>
        <v-btn flat :to="{name: 'HomepagePage'}" active-class="link-active">Homepage</v-btn>
        <v-btn flat :to="{name: 'Directory'}" active-class="link-active">Directory</v-btn>
        <v-btn flat :to="{name: 'Education'}" active-class="link-active">Education</v-btn>
        <v-btn flat :to="{name: 'Events'}" active-class="link-active">Events</v-btn>
        <v-btn flat :to="{name: 'Intelligence'}" active-class="link-active">Intelligence</v-btn>
        <v-btn flat :to="{name: 'OnlineShop'}" active-class="link-active">Online Shop</v-btn>
        <v-btn flat :to="{name: 'ForexLive'}" active-class="link-active">Forex Live</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <router-link :to="{name: 'NewArticle'}" class="header__add-article-btn-container">
      <v-icon x-large class="header__add-article-btn">add_circle</v-icon>
    </router-link>
  </div>
  <!--<div class="header__container">-->
    <!--<div class="header__nav">-->
      <!--<router-link class="header__nav-link" :to="{name: 'Users'}">Users</router-link>-->
      <!--<router-link class="header__nav-link" :to="{name: 'Notifications'}">Notifications</router-link>-->
      <!--<router-link class="header__nav-link" :to="{name: 'MediaCenter'}">Media Center</router-link>-->
      <!--<router-link class="header__nav-link" :to="{name: 'Editors'}">Editors/authors</router-link>-->
      <!--<router-link class="header__nav-link" :to="{name: 'Permissions'}">Permissions</router-link>-->
    <!--</div>-->
    <!--<div class="header__logout">-->
      <!--<span class="header__logout-btn" @click="onLogout">Log Out</span>-->
    <!--</div>-->
  <!--</div>-->
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AHeader',
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  watch: {},
  methods: {
    onLogout () {
      this.$store.dispatch('deuthenticateUser')
      this.$router.replace({name: 'TestLogin'})
    },
    redirectTo (route) {
      this.$router.push(route)
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
@import '~colors';

.header {
  &__nav {
    padding: 0 20px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;

    /deep/ .btn__content {
      text-transform: none;
      font-size: 16px;
    }
  }

  &__nav:nth-child(1) {
    margin-bottom: 6px;
    background: rgb(204, 201, 209);

    /deep/ .btn__content {
      padding: 0 30px;
    }

    /deep/ .toolbar {
      background: rgb(204, 201, 209) !important;
    }
  }

  &__nav:nth-child(2) {
    height: 75px;
    background: $c--light-gray;

    /deep/ .toolbar__content {
      height: 75px !important;
    }

    /deep/ .btn__content {
      padding: 0 20px;
    }

    /deep/ .toolbar {
      background: $c--light-gray !important;
    }
  }

  /deep/ &__add-article-btn-container {
    position: relative;
    width: 60px;
    height: 60px;
    margin-right: 15px;

    &::before {
      content: '';
      position: absolute;
      display: block;
      width: 30px;
      height: 30px;
      background: white;
      left: 14px;
      top: 14px;
    }
  }

  /deep/ &__add-article-btn {
    font-size: 60px !important;
    color: rgb(186, 186, 186);
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;

    &:hover {
      color: rgb(169, 169, 169);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/AHeader/index.vue